// =============================================================================
// WFC REDESIGN — JS ENTRY
// =============================================================================
// Interaction layer for the redesigned screens. Plain ES modules, no framework
// (mirrors the live finestclubs.com stack: vanilla JS + Swiper + Turbolinks).
//
// TURBOLINKS: init runs on `turbolinks:load` (fires on first load AND after every
// Turbolinks navigation). Swiper instances are destroyed on `turbolinks:before-cache`
// so the cached snapshot does not restore duplicated carousel DOM.
//
// WEBPACKER: import this from packs/application.js. Swiper is read off `window.Swiper`
// — in the pack add:  import Swiper from 'swiper/bundle'; window.Swiper = Swiper;
// =============================================================================

import { initReveal } from "./lib/reveal.js";
import { initCarousels, destroyCarousels } from "./lib/carousel.js";
import { initHeader } from "./lib/header.js";
import { initDropdown } from "./lib/dropdown.js";
import { initTabs } from "./lib/tabs.js";
import { initMember } from "./lib/member.js";
import { initModals, closeModals } from "./lib/modal.js";
// NOTE: file is named wfc_events.js, NOT analytics.js — a file literally named
// "analytics.js" is blocked by ad-blockers / privacy filters (EasyPrivacy), which
// this affluent audience runs heavily. See docs/ANALYTICS.md.
import { initAnalytics } from "./lib/wfc_events.js";
import { initPasswordToggle } from "./lib/password_toggle.js";
import { initNewsletterForm } from "./lib/newsletter_form.js";

function boot() {
  // Signal the inline failsafe (see app <head>) that JS is alive, so it won't
  // strip the reveal gate. If this module never loads, the failsafe reveals all.
  window.__wfcReady = true;
  // Analytics binds document-level listeners once, independent of the .wfc root,
  // so it runs before the early return (member/auth pages fire join CTAs too).
  initAnalytics();
  const root = document.querySelector(".wfc");
  if (!root) return;
  initHeader(root);
  initDropdown(root);
  initTabs(root);
  initMember(root);
  initCarousels(root);
  initReveal(root);
  initPasswordToggle(root);
  initNewsletterForm(root);
  initModals(root);
}

// Turbolinks-aware lifecycle, with an immediate initial boot as well. With a
// deferred pack it is possible for `turbolinks:load` to have fired before this
// module attaches its listener; without the immediate boot the header never
// receives its `.is-solid` class while scrolling.
document.addEventListener("turbolinks:load", boot);
document.addEventListener("turbolinks:before-cache", destroyCarousels);
document.addEventListener("turbolinks:before-cache", closeModals);

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
